<template>
  <BaseCard
    height="100%"
    width="100%"
    class="d-flex flex-column justify-start "
    color="grey lighten-5"
  >
    <!-- The Share Modal Title -->
    <TheShareModalHeader
      :title="shareModalHeaderTitle"
      :closeActionDisabled="isShareModalPersistent"
      class="z-index-1"
    ></TheShareModalHeader>
    <!-- The Share Modal Content -->
    <div
      class="flex-grow-1 scroll--overflow-y"
      :style="`${!$vuetify.breakpoint.xs ? 'max-height:75vh' : ''}`"
    >
      <BaseLinearProgress
        v-show="isFetchingData"
        color="secondary"
        :indeterminate="true"
        :height="4"
        :absolute="true"
      ></BaseLinearProgress>
      <TheShareModalPostTypeSelection
        v-if="!postType"
      ></TheShareModalPostTypeSelection>
      <TheShareModalPostForm
        v-else-if="!post.id || isEditingPost"
      ></TheShareModalPostForm>
      <TheShareModalPostManagement v-else></TheShareModalPostManagement>
    </div>
  </BaseCard>
</template>

<script>
// Librairies
import { mapGetters, mapState } from "vuex";

// Components
import TheShareModalHeader from "./TheShareModalHeader";
import TheShareModalPostForm from "./TheShareModalPostForm";
import TheShareModalPostManagement from "./TheShareModalPostManagement";
import TheShareModalPostTypeSelection from "./TheShareModalPostTypeSelection";

export default {
  name: "TheShareModal",
  components: {
    TheShareModalHeader,
    TheShareModalPostForm,
    TheShareModalPostManagement,
    TheShareModalPostTypeSelection
  },
  // DATAs
  computed: {
    ...mapState({
      post: state => state.share.post,
      isShareModalPersistent: state => state.share.isShareModalPersistent,
      isEditingPost: state => state.share.isEditingPost,
      isFetchingData: state => state.share.isFetchingData
    }),
    ...mapGetters({
      postType: "share/postType"
    }),
    shareModalHeaderTitle() {
      if (this.isEditingPost) return "Edition";
      if (this.post.id) return "Mon partage";
      return "Partager";
    }
  }
};
</script>

<style lang="scss" scoped></style>
